<template>
  <div class="wrap">
    <div class="container">
      <router-view></router-view>
    </div>
    <nav-web></nav-web>
  </div>
</template>
<script>
import navWeb from '@/components/nav'
export default {
  name: "home",
  components: {
    'nav-web': navWeb
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home.vue